import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { filterCategories } from "@/lib/site";

const toneClass: Record<string, string> = {
  primary: "bg-primary-50 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export default function CategoryGrid() {
  return (
    <section className="bg-background-50">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="Categories"
          title="按领域找你想跟的事件"
          description="不同领域的事件有不同的发酵节奏。先选一个方向，再决定要不要长期跟下去。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {filterCategories.map((category) => (
            <Link
              key={category.id}
              to={`/topics?cat=${category.id}`}
              className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-md border ${toneClass[category.tone]}`}
              >
                <i className={`${category.icon} text-xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {category.label}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">
                {category.desc}
              </p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{category.count} 个档案</span>
                <i
                  className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}